import type { GetServerSidePropsContext, InferGetServerSidePropsType } from 'next';
import { Layout } from '@/components/commons';
import React from 'react';
import { NextPageWithLayout } from '@/pages/_app';
import StudyAbroadContent from '@/components/studyAbroad/StudyAbroadContent';

const StudyAbroadPage: NextPageWithLayout<InferGetServerSidePropsType<typeof getServerSideProps>> = () => {
  return <StudyAbroadContent />;
};

export async function getServerSideProps({ locale }: GetServerSidePropsContext) {
  return {
    props: {
      messages: (await import(`@/locales/${locale}.json`)).default,
    },
  };
}

StudyAbroadPage.getLayout = (page: React.ReactElement) => {
  return <Layout>{page}</Layout>;
};

export default StudyAbroadPage;
